export function setHeadersByRole(user, headers){
    let extra = [];

    if (user.role === "Member") {
      extra = ["PRIMARY_DIAG"];
    }
  
    headers = headers.filter((field) => {
      return !extra.includes(field.value);
    });
  
    return headers;
}

